import { render, staticRenderFns } from "./EditPhotoGallery.vue?vue&type=template&id=166ec99e"
import script from "./EditPhotoGallery.vue?vue&type=script&lang=js"
export * from "./EditPhotoGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSeparator})
